/* Add to cart for the pack pickers.

   The markup is a real <form action="/cart/add">, so with JavaScript broken or
   still loading the button is a normal Shopify add and the visitor lands on
   /cart. This file is the enhancement on top: it posts the same form to
   /cart/add.js, opens the drawer the theme already renders, and only falls
   back to a native submit if anything in that path is missing. A store's cart
   is the one place where a clever failure costs real money, so every branch
   here ends in a working add.
*/
(function () {
  var SELECTOR = 'form[data-silt-add]';

  function refreshBubble() {
    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + '?section_id=cart-icon-bubble'
      : '/?section_id=cart-icon-bubble')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('.shopify-section');
        var current = document.getElementById('cart-icon-bubble');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  function openDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return false;

    /* Dawn's drawer renders from the sections API. Asking for its own section
       keeps the contents in step with what was just added. */
    return fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (typeof drawer.renderContents === 'function') {
          drawer.renderContents({ sections: sections });
        } else if (typeof drawer.open === 'function') {
          drawer.open();
        }
        return true;
      })
      .catch(function () { return false; });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest ? event.target.closest(SELECTOR) : null;
    if (!form) return;

    var button = form.querySelector('[type="submit"]');
    if (button && button.disabled) return;

    event.preventDefault();

    var body = new FormData(form);
    if (button) {
      /* innerHTML, not textContent: the pack picker's button carries its price
         in a span, and a text restore flattened it. */
      button.dataset.siltLabel = button.innerHTML;
      button.classList.add('is-loading');
    }

    fetch('/cart/add.js', { method: 'POST', body: body, headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        return response.json();
      })
      .then(function () {
        if (button) {
          button.classList.remove('is-loading');
          button.classList.add('is-added');
          button.textContent = button.dataset.siltAdded || 'Added';
          window.setTimeout(function () {
            button.classList.remove('is-added');
            if (button.dataset.siltLabel) button.innerHTML = button.dataset.siltLabel;
          }, 2200);
        }
        refreshBubble();
        return openDrawer();
      })
      .catch(function () {
        /* Anything at all went wrong: hand it back to the browser, which
           knows how to post a form. */
        if (button) button.classList.remove('is-loading');
        form.submit();
      });
  });
})();
